module.exports = __webpack_public_path__ + "static/img/10.fce98c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/10.png
// module id = Aln7
// module chunks = 0